
import React from 'react';
import { Image } from '@themesberg/react-bootstrap';

import MiracleWhiteLogo from "../assets/img/MW_Logo.png";

export default (props) => {

  const { show } = props;

  return (
    <div className={`preloader bg-soft flex-column justify-content-center align-items-center ${show ? "" : "show"}`}>
      <Image className="loader-element animate__animated animate__jackInTheBox" src={MiracleWhiteLogo} height={40} />
    </div>
  );
};
